import * as React from 'react';
import * as ImageZoom from './lib/js-image-zoom';

interface ImageZoomProps {
  width?: number;
  height?: number;
  zoomWidth?: number;
  img: string;
  scale?: number;
  offset?: object;
  zoomStyle?: string;
  zoomLensStyle?: string;
  zoomPosition?: string;
  handleClick?: (event: React.MouseEvent<HTMLElement>) => void;
}
class ReactImageZoom extends React.Component<ImageZoomProps> {
  container: undefined | HTMLElement;
  imageZoom: any;
  constructor(props) {
    super(props);
    this.container = undefined;
  }

  componentDidMount() {
    this.rerenderImageZoom(this.props);
  }

  componentWillUnmount() {
    this.imageZoom.kill();
    this.imageZoom = void 0;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.kill();
      this.rerenderImageZoom(nextProps);
    }
  }

  rerenderImageZoom(props) {
    this.imageZoom = new (ImageZoom as any)(
      this.refs.zoomRef,
      JSON.parse(JSON.stringify(props)),
    );
  }

  setup() {
    this.imageZoom.setup();
  }

  kill() {
    this.imageZoom.kill();
  }

  render() {
    return (
      <div
        className="image-zoom-container"
        ref="zoomRef"
        onClick={this.props.handleClick}
      />
    );
  }
}

export default ReactImageZoom;
